import { render, staticRenderFns } from "./Tagposts.vue?vue&type=template&id=71564cb8&"
import script from "./Tagposts.vue?vue&type=script&lang=js&"
export * from "./Tagposts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tagposts.vue"
export default component.exports